module.exports = __webpack_public_path__ + "img/editalEletronico3.8c81b7ea.jpg";